export default "__VITE_ASSET__Dt2wJMsM__"